import { affiliateFaqData } from '../Common/AffiliateFaqData';
/* global gtag */

const affiliateSignupUrl = "https://easyimagetotext.lemonsqueezy.com/affiliates";

function AffiliatePage({ isIndianUser }){

    const isShowConsole = process.env.NODE_ENV === 'development';

    const faqElements = affiliateFaqData.map((ele, idx) => {
        return(
            <div className='affiliateFaqEle' key={idx}>
                <div className='question'>{ele.question}</div>
                <div className='answer'>{ele.answer}</div>
            </div>
        )
    });

    const initiateAffiliateSignup = e => {
        try{
            window.open(affiliateSignupUrl, '_blank', 'noopener,noreferrer');
        }catch(err){
            console.log('error in initiateAffiliateSignup method: ', err);
            
        }
    }
    
    return(
        <div className='parentDiv'>
            <div className='mainDiv affiliatePage'>
                <div className="section1">
                    <div className="wrapper">
                        <div className="logo">
                            <img src={'/TransLogo.png'} alt='app logo'/>
                        </div>
                        <div className="title">Become an affiliate & earn 30% on each sale!</div>
                        <div className="sub-title">Refer customers and start earning today!</div>
                        <div className="ctaBtn" onClick={initiateAffiliateSignup}>Become an affiliate</div>
                    </div>
                </div>
                <div className="section2">
                    <div className="wrapper">
                        <div className='affiliateFaqContainer'>
                            {faqElements}
                        </div>
                    </div>  
                </div>
                <div className="section3">
                    <div className='wrapper'>
                        <div className='ctaContainer'>
                            <div className='ctaTxt'>Start earning today!</div>
                            <div className='ctaBtn' onClick={initiateAffiliateSignup}>Become an affiliate</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AffiliatePage;